(function () {
  'use strict';

  /* @ngdoc object
   * @name championship.assignMatches
   * @description
   *
   */
  angular
    .module('neo.home.championships.championship.assignMatches', [
      'ui.router'
    ]);
}());
